import React from "react";
import "./TechCommittee.css";
import "./InProgress.css";

import { MiniProfile } from "../MiniProfile";
import { ComingSoon } from "../ComingSoon";

export const TechCommittee = () => {
  const profiles = [
    {
      title: "Professor",
      firstName: "Christian",
      surname: "Becker",
      university: "Universität Stuttgart",
      image: "./images/profiles/Becker.jpg",
      googlescholar:
        "https://scholar.google.de/citations?user=kvDsx-8AAAAJ&hl=en",
    },
    {
      title: "Professor",
      firstName: "Paolo",
      surname: "Bellavista",
      university: "University College Cork",
      image: "./images/profiles/Bellavista.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=vVSZ4rUAAAAJ&hl=it",
      researchgate: "https://www.researchgate.net/profile/Paolo-Bellavista/16",
      linkedin: null,
      twitter: null,
    },

    {
      title: "Professor",
      firstName: "Shameek",
      surname: "Bhattacharjee",
      university: "Western Michigan University",
      image: "./images/profiles/Bhattacharjee.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=yP7rQY8AAAAJ&hl=en",
      researchgate:
        "https://www.researchgate.net/profile/Shameek-Bhattacharjee",
      linkedin: "https://www.linkedin.com/in/shameek-bhattacharjee-43500b39/",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Shuvra",
      surname: "Bhattacharyya",
      university: "University of Maryland",
      image: "./images/profiles/Bhattacharyya.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=rNpUIKAAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Shuvra-Bhattacharyya",
      linkedin: null,
      twitter: null,
    },
    {
      title: "",
      firstName: "Chiara",
      surname: "Boldrini",
      university: "IIT-CNR",
      image: "./images/profiles/Boldrini.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=rCrzxbsAAAAJ&hl=en",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/chiaraboldrini/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Georgios",
      surname: "Bouloukakis",
      university: "Telecom SudParis",
      image: "./images/profiles/Bouloukakis.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.fr/citations?user=dNlblr8AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Georgios-Bouloukakis",
      linkedin: "https://www.linkedin.com/in/bouloukakis/?originalSubdomain=fr",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Tristan",
      surname: "Braud",
      university: "The Hong Kong University of Science and Technology",
      image: "./images/profiles/braud.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.fr/citations?user=ZOZtoQUAAAAJ&hl=fr",
      researchgate: "https://www.researchgate.net/profile/Tristan-Braud/4",
      linkedin:
        "https://www.linkedin.com/in/tristan-braud-38752213a/?originalSubdomain=hk",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Dario",
      surname: "Bruneo",
      university: "Universita di Messina, Italy",
      image: "./images/profiles/bruneo.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=ufUdkigAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Dario-Bruneo",
      linkedin: "https://www.linkedin.com/in/dariobruneo/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Claudio",
      surname: "Cicconetti",
      university: "IIT-CNR",
      image: "./images/profiles/Cicconetti.jpg",
      bio: null,
      googlescholar: null,
      researchgate: "https://www.researchgate.net/profile/Claudio-Cicconetti/2",
      linkedin: "https://www.linkedin.com/in/cicconetti/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Gabriele",
      surname: "Civitarese",
      university: "University of Milan",
      image: "./images/profiles/civitarese.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.it/citations?user=iwh7f5cAAAAJ&hl=it",
      researchgate: "https://www.researchgate.net/profile/Gabriele-Civitarese",
      linkedin:
        "https://www.linkedin.com/in/gabrielecivitarese/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Alexandre",
      surname: "da Silva Veith",
      university: "Nokia Bell Labs",
      image: "./images/profiles/Veith.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=ZrkbeCQAAAAJ&hl=en",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/alexandre-da-silva-veith-1837b49/?originalSubdomain=be",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Luca",
      surname: "Davoli",
      university: "University of Parma",
      image: "./images/profiles/Davoli.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.it/citations?user=u8qfji4AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Luca-Davoli",
      linkedin: null,
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Fabrizio",
      surname: "De Vita",
      university: "University of Messina",
      image: "./images/profiles/Vita.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=HZuEzy8AAAAJ&hl=it",
      researchgate: "https://www.researchgate.net/profile/Fabrizio-De-Vita",
      linkedin: null,
      twitter: null,
    },

    {
      title: "Dr",
      firstName: "Ivana",
      surname: "Dusparic",
      university: "University College Cork",
      image: "./images/profiles/Dusparic.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=CrGGAccAAAAJ&hl=en",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/ivana-dusparic/?originalSubdomain=ie",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Schahram",
      surname: "Dustdar",
      university: "Vienna University of Technology",
      image: "./images/profiles/Dustdar.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=0n5S6uUAAAAJ&hl=en",
      researchgate: null,
      linkedin: null,
      //twitter: "https://x.com/dustdar?lang=en",
    },

    {
      title: "Professor",
      firstName: "Salma",
      surname: "El Malaki",
      university: "University of California",
      image: "./images/profiles/Elmalaki.png",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=6QKACtcAAAAJ&hl=en",
      researchgate: null,
      linkedin: null,
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Stefan",
      surname: "Fischer",
      university: "University of Lubeck",
      image: "./images/profiles/Fischer.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=_fYPvl4AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Stefan-Fischer-5/12",
      linkedin:
        "https://www.linkedin.com/in/stefan-fischer-uzl/?originalSubdomain=de",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Huber",
      surname: "Flores",
      university: "University of Tartu, Estonia",
      image: "./images/profiles/Flores.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=M9gkFKUAAAAJ&hl=en",
      researchgate: null,
      linkedin: null,
      //twitter: "https://x.com/huberflores",
    },
    {
      title: "Dr",
      firstName: "Georgantas",
      surname: "Nikolaos",
      university: "INRIA",
      image: "./images/profiles/Georgantas.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.fr/citations?user=ZckZFsEAAAAJ&hl=en",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/nikolaos-georgantas-569b127/?originalSubdomain=fr",
      twitter: null,
    },

    {
      title: "Dr",
      firstName: "Estrid",
      surname: "He",
      university: "RMIT University",
      image: "./images/profiles/He.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com.au/citations?user=Lwso-psAAAAJ&hl=en",
      researchgate: null,
      linkedin: null,
      twitter: null,
    },
    {
      title: "Mr",
      firstName: "Salil",
      surname: "Kanhere",
      university: "UNSW Sydney",
      image: "./images/profiles/Kanhere.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=sgqmaPMAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Salil-Kanhere",
      linkedin:
        "https://www.linkedin.com/in/salilkanhere/?originalSubdomain=au",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Ulf",
      surname: "Kulau",
      university: "Hamburg University of Technology",
      image: "./images/profiles/Kulau.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.de/citations?user=UgF32_EAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Ulf-Kulau",
      linkedin:
        "https://www.linkedin.com/in/ulf-kulau-b5b91287/?originalSubdomain=de",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Stephen",
      surname: "Lee",
      university: "University of Pittsburgh",
      image: "./images/profiles/Lee.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=qsjlH3AAAAAJ&hl=en",
      researchgate: null,
      linkedin: "https://www.linkedin.com/in/stephenlee86/",
      twitter: null,
    },

    {
      title: "Professor",
      firstName: "Takuya",
      surname: "Maekawa",
      university: "Osaka University",
      image: "./images/profiles/Maekawa.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=CxP8QCwAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Takuya-Maekawa",
      linkedin: null,
      twitter: null,
    },

    {
      title: "Dr",
      firstName: "Fidan",
      surname: "Mehmeti",
      university: "Technical University of Munich",
      image: "./images/profiles/Mehmeti.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=LukZDtkAAAAJ&hl=en",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/fidan-mehmeti-88619279/?originalSubdomain=de",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Francesca",
      surname: "Meneghello",
      university: "University of Padova, Italy",
      image: "./images/profiles/meneghello.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=Gd5P7VgAAAAJ&hl=it",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Francesca-Meneghello-2170851262",
      linkedin:
        "https://www.linkedin.com/in/francesca-meneghello/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Jin",
      surname: "Nakazawa",
      university: "Keio University",
      image: "./images/profiles/Nakazawa.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.co.in/citations?user=Lj6r908AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Jin-Nakazawa",
      linkedin: null,
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Kien",
      surname: "Nguyen",
      university: "Chiba University",
      image: "./images/profiles/kiennguyen.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.co.jp/citations?user=RsfiHOEAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Kien-Nguyen-65",
      linkedin: "https://www.linkedin.com/in/kienng/?originalSubdomain=jp",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Le",
      surname: "Nguyen",
      university: "University of Oulu",
      image: "./images/profiles/Nguyen.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=tow0oVoAAAAJ&hl=en",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Le-Ngu-Nguyen-2119529715",
      linkedin: "https://www.linkedin.com/in/nlnngu/?originalSubdomain=fi",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Petteri",
      surname: "Nurmi",
      university: "Technical University of Munich",
      image: "./images/profiles/Nurmi.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=P5kDLb0AAAAJ&hl=en",
      researchgate: null,
      linkedin: null,
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Ella",
      surname: "Peltonen",
      university: "University of Oulu",
      image: "./images/profiles/Peltonen.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=P5kDLb0AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Ella-Peltonen",
      linkedin: "https://www.linkedin.com/in/aluidynlia/?originalSubdomain=fi",
      //twitter: "https://www.linkedin.com/in/aluidynlia/?originalSubdomain=fi",
    },
    {
      title: "Professor",
      firstName: "Antonio",
      surname: "Puliafito",
      university: "University of Messina",
      image: "./images/profiles/Puliafito.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.it/citations?user=Rgi_tYgAAAAJ&hl=it",
      researchgate: "https://www.researchgate.net/profile/Antonio-Puliafito",
      linkedin: null,
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Susan",
      surname: "Rea",
      university: "Nimbus Research Centre",
      image: "./images/profiles/Rea.jpeg",
      bio: null,
      googlescholar: null,
      researchgate: "https://www.researchgate.net/profile/Susan-Rea",
      linkedin:
        "https://www.linkedin.com/in/susan-rea-nimbus-mtu/?originalSubdomain=ie",
      twitter: null,
    },

    {
      title: "Professor",
      firstName: "Francesca",
      surname: "Righetti",
      university: "University of Pisa",
      image: "./images/profiles/Righetti.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=HE4adMIAAAAJ&hl=it",
      researchgate: "https://www.researchgate.net/profile/Francesca-Righetti-2",
      linkedin:
        "https://www.linkedin.com/in/francescarighetti/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Nirmalya",
      surname: "Roy",
      university: "University of Maryland Baltimore County",
      image: "./images/profiles/Roy.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=6KQI1ekAAAAJ&hl=en",
      researchgate: null,
      linkedin: "https://www.linkedin.com/in/nirmalya-roy-80583126/",
      twitter: null,
    },

    {
      title: "Professor",
      firstName: "Gregor",
      surname: "Schiele",
      university: "University of Duisburg-Essen",
      image: "./images/profiles/Schiele.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.de/citations?user=jhSvu1wAAAAJ&hl=de",
      researchgate: null,
      linkedin:
        "https://www.linkedin.com/in/gregor-schiele-42426948/?locale=en_US",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Francisco",
      surname: "Silva",
      university: "Federal University of Maranhao",
      image: "./images/profiles/Silva.png",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=S8dDtXQAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Francisco-Silva-22",
      linkedin: null,
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Simone",
      surname: "Silvestri",
      university: "University of Kentucky",
      image: "./images/profiles/Silvestri.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=5aCq9GoAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Simone-Silvestri-3",
      linkedin: "https://www.linkedin.com/in/simone-silvestri-7a04374/",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Eirini",
      surname: "Eleni Tsiropoulou",
      university: "University of New Mexico",
      image: "./images/profiles/Tsiropoulou.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.gr/citations?user=q9WpZkgAAAAJ&hl=el",
      researchgate:
        "https://www.researchgate.net/profile/Eirini-Eleni-Tsiropoulou",
      linkedin:
        "https://www.linkedin.com/in/eirini-eleni-tsiropoulou-7a212130/",
      //twitter: "https://x.com/tsiropoulou_ee",
    },
    {
      title: "Dr",
      firstName: "Carlo",
      surname: "Vallati",
      university: "University of Pisa",
      image: "./images/profiles/Vallati.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=WRVWjE4AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Carlo-Vallati/2",
      linkedin:
        "https://www.linkedin.com/in/carlo-vallati-a796aa19/?originalSubdomain=it",
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Hirozumi",
      surname: "Yamaguchi",
      university: "Osaka University",
      image: "./images/profiles/Yamaguchi.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=pUpK9hYAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Hirozumi-Yamaguchi",
      linkedin: null,
      twitter: null,
    },
    {
      title: "Professor",
      firstName: "Keiichi",
      surname: "Yasumoto",
      university: "Nara Institute of Science and Technology",
      image: "./images/profiles/Yasumoto.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=ksliY64AAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Keiichi-Yasumoto",
      linkedin: null,
      twitter: null,
    },
  ];

  const sortedProfiles = profiles.sort((a, b) =>
    a.surname.localeCompare(b.surname)
  );

  const industryProfiles = [
    {
      title: "Dr",
      firstName: "Sam",
      surname: "Heshmati",
      university: "Bosch Research - Bosch Center for Artificial Intelligence",
      image: "./images/profiles/heshmati.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=gmJxDTwAAAAJ&hl=pt-PT",
      researchgate: null,
      linkedin: "https://www.linkedin.com/in/sam-heshmati/",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Dimitra",
      surname: "Tsigkari",
      university: "Telefonica Research",
      image: "./images/profiles/Tsigkari.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=JNQM4eUAAAAJ&hl=en",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Dimitra-Tsigkari-2176402007",
      linkedin:
        "https://www.linkedin.com/in/dimitra-tsigkari/?originalSubdomain=es",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Gürkan",
      surname: "Solmaz",
      university: "NEC Laboratories Europe Germany",
      image: "./images/profiles/Gurkan.png",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=Y-XTnQEAAAAJ&hl=en",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Guerkan-Solmaz-2168649332",
      linkedin: "https://www.linkedin.com/in/gsolmaz/?locale=de_DE",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Steven",
      surname: "Liang",
      university: "University of Calgary",
      image: "./images/profiles/Liang.jpeg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=mAkyE1sAAAAJ&hl=en",
      researchgate: "https://www.researchgate.net/profile/Steve-Liang-2",
      linkedin:
        "https://www.linkedin.com/in/steve-liang-198b44/?originalSubdomain=ca",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Afrooz",
      surname: "Ansaripour",
      university: "Walmart",
      image: "./images/profiles/afrooz.jpg",
      bio: null,
      googlescholar:
        "https://scholar.google.com/citations?user=wgd-vpAAAAAJ&hl=en",
      researchgate: null,
      linkedin: "https://www.linkedin.com/in/afroozansaripour/overlay/photo/",
      twitter: null,
    },
  ];

  const sortedIndustryProfiles = industryProfiles.sort((a, b) =>
    a.surname.localeCompare(b.surname)
  );

  /*
  const industryProfiles = [
    {
      title: "Dr",
      firstName: "Dimitra",
      surname: "Tsigkari",
      university: "Telefonica Research",
      image: "./images/profiles/Tsigkari.jpeg",
      linkedin:
        "https://www.linkedin.com/in/dimitra-tsigkari/?originalSubdomain=es",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=JNQM4eUAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Eric D.",
      surname: "Simmon",
      university: "National Institute of Standards and Technology",
      image: "./images/profiles/Simmon.jpeg",
      linkedin: "https://www.linkedin.com/in/eric-simmon-93754620/",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Eric-Simmon-2075131240",
      googlescholar: null,
      twitter: null,
    },
    {
      title: "",
      firstName: "Gürkan",
      surname: "Solmaz",
      university: "NEC Laboratories Europe Germany",
      image: "./images/profiles/Gurkan.png",
      linkedin: "https://www.linkedin.com/in/gsolmaz/?locale=de_DE",
      researchgate:
        "https://www.researchgate.net/scientific-contributions/Gurkan-Solmaz-2003841808",
      googlescholar:
        "https://scholar.google.com/citations?user=Y-XTnQEAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Luis",
      surname: "Munoz",
      university: "Telefonica Research",
      image: "./images/profiles/Luis.png",
      linkedin:
        "https://www.linkedin.com/in/lmunoz-gonzalez/?originalSubdomain=es",
      researchgate:
        "https://www.researchgate.net/profile/Luis-Munoz-Gonzalez-2",
      googlescholar:
        "https://scholar.google.com/citations?user=NItHMRYAAAAJ&hl=es",
      twitter: null,
    },
    {
      title: "",
      firstName: "Martin",
      surname: "Saerbeck",
      university: "TUV SUD Germany",
      image: "./images/profiles/Martin.jpeg",
      linkedin:
        "https://www.linkedin.com/in/martinsaerbeck/?originalSubdomain=sg",
      researchgate: "https://www.researchgate.net/profile/Martin-Saerbeck",
      googlescholar:
        "https://scholar.google.com/citations?user=Ogx_H5MAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Steven",
      surname: "Liang",
      university: "University of Calgary",
      image: "./images/profiles/Liang.jpeg",
      linkedin:
        "https://www.linkedin.com/in/steve-liang-198b44/?originalSubdomain=ca",
      researchgate: "https://www.researchgate.net/profile/Steve-Liang-2",
      googlescholar:
        "https://scholar.google.com/citations?user=mAkyE1sAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Suryadipta",
      surname: "Majumdar",
      university: "Concordia University",
      image: "./images/profiles/Suryadipta.jpeg",
      linkedin:
        "https://www.linkedin.com/in/suryadiptamajumdar/?originalSubdomain=ca",
      researchgate: "https://www.researchgate.net/profile/Suryadipta-Majumdar",
      googlescholar:
        "https://scholar.google.ca/citations?user=S4x0by4AAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Yoshihiro",
      surname: "Osakabe",
      university: "Hitachi Ltd.",
      image: "./images/profiles/Yoshihiro.png",
      linkedin: "https://www.linkedin.com/in/yshroskb/?originalSubdomain=jp",
      researchgate: "https://www.researchgate.net/profile/Yoshihiro-Osakabe",
      googlescholar: null,
      twitter: null,
    },
  ];
  */

  const posterProfiles = [
    {
      title: "",
      firstName: "Federico",
      surname: "Corò",
      university: "University of Padova",
      image: "./images/profiles/Federico.png",
      linkedin:
        "https://www.linkedin.com/in/federico-cor%C3%B2-90098180/?originalSubdomain=it",
      researchgate: "https://www.researchgate.net/profile/Federico-Coro",
      googlescholar:
        "https://scholar.google.it/citations?user=2Mwb6ugAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Lorenzo",
      surname: "Palazzetti",
      university: "University of Florence",
      image: "./images/profiles/Lorenzo.jpeg",
      linkedin:
        "https://www.linkedin.com/in/lorenzo-palazzetti-a706b61a3/?originalSubdomain=it",
      researchgate: "https://www.researchgate.net/profile/Lorenzo-Palazzetti",
      googlescholar:
        "https://scholar.google.com/citations?user=pHADTUQAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Sherif",
      surname: "Abdelwahed",
      university: "Virginia Commonwealth University",
      image: "./images/profiles/sherif.jpg",
      linkedin: "https://www.linkedin.com/in/sherifs/",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=ZUfEfSAAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Vincenzo",
      surname: "Agate",
      university: "University of Palermo, Italy",
      image: "./images/profiles/agate.jpg",
      linkedin: "https://www.linkedin.com/in/vincenzo-agate-408a15173/",
      researchgate: "https://www.researchgate.net/profile/Vincenzo-Agate",
      googlescholar:
        "https://scholar.google.co.in/citations?user=CL-vdZUAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Christine",
      surname: "Bassem",
      university: "Wellesley College, USA",
      image: "./images/profiles/picture.png",
      linkedin: "https://www.linkedin.com/in/christine-b-7844964a/",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=wxcghcwAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Armir",
      surname: "Bujari",
      university: "University of Bologna, Italy",
      image: "./images/profiles/armir.jpg",
      linkedin:
        "https://www.linkedin.com/in/armir-bujari-7a2a5328/?originalSubdomain=it",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=b37gO9kAAAAJ&hl=it",
      twitter: null,
    },
    {
      title: "",
      firstName: "Sandip",
      surname: "Chakraborty",
      university: "Indian Institute of Technology Kharagpur, India",
      image: "./images/profiles/sandip.jpg",
      linkedin:
        "https://www.linkedin.com/in/sandip-chakraborty-iitkgp/?originalSubdomain=in",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=pQ6C8YAAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Marco",
      surname: "Pettorali",
      university: "University of Pisa, Italy",
      image: "./images/profiles/pettorali.jpg",
      linkedin:
        "https://www.linkedin.com/in/marco-pettorali-9bb78a228/overlay/photo/?locale=es_ES&trk=people-guest_people_search-card",
      researchgate: "https://www.researchgate.net/profile/Marco-Pettorali-2",
      googlescholar:
        "https://www.linkedin.com/in/marco-pettorali-9bb78a228/overlay/photo/?locale=es_ES&trk=people-guest_people_search-card",
      twitter: null,
    },

    {
      title: "",
      firstName: "Georgios",
      surname: "Eleftherakis",
      university: "Penn State University Brandywine, USA",
      image: "./images/profiles/georgios.jpg",
      linkedin: "https://www.linkedin.com/in/george-eleftherakis-5415281/",
      researchgate: null,
      googlescholar:
        "https://scholar.google.co.uk/citations?user=-ApDw5sAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Olamide T.",
      surname: "Tawose",
      university: "Lincoln University, USA",
      image: "./images/profiles/Olamide.jpg",
      linkedin: "https://www.linkedin.com/in/olamide-timothy-tawose-b424b766/",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=WhQYqMYAAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "Dr",
      firstName: "Neda",
      surname: "Bazyar Shourabi",
      university: "Penn State University York, USA",
      image: "./images/profiles/bazyar.jpg",
      linkedin:
        "https://www.linkedin.com/in/neda-bazyar-shourabi-phd-b19807101/",
      researchgate: null,
      googlescholar:
        "https://scholar.google.com/citations?user=4SqlFlEAAAAJ&hl=en",
      twitter: null,
    },
  ];

  /*
,
    {
      title: "",
      firstName: "Ko",
      surname: "Watanabe",
      university: "University of Kaiserslautern",
      image: "./images/profiles/Ko.png",
      linkedin: "https://www.linkedin.com/in/ko-watanabe/?originalSubdomain=de",
      researchgate: "https://www.researchgate.net/profile/Ko-Watanabe-3",
      googlescholar:
        "https://scholar.google.com/citations?user=AluAUmEAAAAJ&hl=ja",
      twitter: null,
    },
    {
      title: "",
      firstName: "Yasue",
      surname: "Kishino",
      university: "NTT Communication Science Laboratories",
      image: "./images/profiles/Yasue.jpeg",
      linkedin: null,
      researchgate: "https://www.researchgate.net/profile/Yasue-Kishino",
      googlescholar: null,
      twitter: null,
    },
    {
      title: "",
      firstName: "Yu",
      surname: "Enokibori",
      university: "Nagoya University",
      image: "./images/profiles/Yu.jpeg",
      linkedin: null,
      researchgate: "https://www.researchgate.net/profile/Yu-Enokibori",
      googlescholar: null,
      twitter: null,
    },
    {
      title: "",
      firstName: "Sajjad",
      surname: "Ghobadi",
      university: "University of Perugia",
      image: "./images/profiles/Sajjad.jpeg",
      linkedin:
        "https://www.linkedin.com/in/sajjad-ghobadi-4b61a7b9/?originalSubdomain=it",
      researchgate: "https://www.researchgate.net/profile/Sajjad-Ghobadi-Babi",
      googlescholar:
        "https://scholar.google.com/citations?user=-qvmO34AAAAJ&hl=en",
      twitter: null,
    },
    {
      title: "",
      firstName: "Teruhiro",
      surname: "Mizumoto",
      university: "Osaka University",
      image: "./images/profiles/Teruhiro.png",
      linkedin: null,
      researchgate: "https://www.researchgate.net/profile/Teruhiro-Mizumoto",
      googlescholar:
        "https://scholar.google.co.jp/citations?user=5oNkF1AAAAAJ&hl=ja",
      twitter: null,
    },
    {
      title: "",
      firstName: "Yugo",
      surname: "Nakamura",
      university: "Kyushu University",
      image: "./images/profiles/Yugo.jpg",
      linkedin: null,
      researchgate: "https://www.researchgate.net/profile/Yugo-Nakamura",
      googlescholar:
        "https://scholar.google.co.jp/citations?user=fUhgPscAAAAJ&hl=en",
      twitter: null,
    },

    {
      title: "",
      firstName: "Ayumi",
      surname: "Ohnishi",
      university: "Kobe University",
      image: "./images/profiles/Ayumi.png",
      linkedin: null,
      researchgate: "https://www.researchgate.net/profile/Ayumi-Ohnishi",
      googlescholar:
        "https://scholar.google.com/citations?user=Zzhh5zgAAAAJ&hl=ja",
      twitter: null,
    },
        {
      title: "",
      firstName: "Hyuckjin",
      surname: "Choi",
      university: "Kyushu University",
      image: "./images/profiles/Hyuckjin.png",
      linkedin:
        "https://www.linkedin.com/in/hyuckjin-choi-399426270/?originalSubdomain=jp",
      researchgate: "https://www.researchgate.net/profile/Hyuckjin-Choi-2",
      googlescholar:
        "https://scholar.google.co.kr/citations?user=1pZBLoIAAAAJ&hl=ko",
      twitter: null,
    },



  */

  const sortedPosterProfiles = posterProfiles.sort((a, b) =>
    a.surname.localeCompare(b.surname)
  );

  return (
    <div className="tech-profile-page-layout">
      <h2 className="tech-title">Research Track Technical Program Committee</h2>
      <div className="tech-profile-layout">
        {sortedProfiles.map(function (data) {
          return <MiniProfile props={data} className="tech-profile-item" />;
        })}
      </div>
      <h2 className="tech-title">Industry Track Technical Program Committee</h2>
      <div className="tech-profile-layout">
        {sortedIndustryProfiles.map(function (data) {
          return <MiniProfile props={data} className="tech-profile-item" />;
        })}
      </div>{" "}
      <h2 className="tech-title">
        Poster/Demo Track Technical Program Committee
      </h2>
      <div className="tech-profile-layout">
        {posterProfiles.map(function (data) {
          return <MiniProfile props={data} className="tech-profile-item" />;
        })}
      </div>
    </div>
  );
};
